var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg96C95(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star-off",
    clipPath: "url(#clip0_0_12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.89676 3.12487L7.68407 1.52941C7.71329 1.47038 7.75842 1.42069 7.81437 1.38595C7.87032 1.35121 7.93487 1.3328 8.00073 1.3328C8.06659 1.3328 8.13114 1.35121 8.18709 1.38595C8.24304 1.42069 8.28817 1.47038 8.31739 1.52941L9.85734 4.64899C9.95865 4.85443 10.1084 5.03215 10.2936 5.16688C10.4788 5.30161 10.694 5.38929 10.9206 5.42239L14.3645 5.92643C14.4298 5.93589 14.4911 5.96341 14.5415 6.0059C14.592 6.04839 14.6295 6.10414 14.6499 6.16685C14.6703 6.22956 14.6727 6.29673 14.6569 6.36076C14.6411 6.42478 14.6077 6.48311 14.5605 6.52914L12.4026 8.63065M11.9637 11.9638L12.2503 13.6339C12.2619 13.6991 12.2548 13.7663 12.23 13.8277C12.2052 13.8891 12.1636 13.9423 12.11 13.9812C12.0565 14.0202 11.993 14.0433 11.9269 14.0479C11.8609 14.0525 11.7948 14.0384 11.7364 14.0073L8.65778 12.3885C8.45497 12.2818 8.22927 12.2261 8.00013 12.2261C7.771 12.2261 7.5453 12.2818 7.34249 12.3885L4.26458 14.0073C4.20614 14.0382 4.14018 14.0521 4.07422 14.0474C4.00826 14.0427 3.94493 14.0196 3.89145 13.9807C3.83797 13.9418 3.79648 13.8887 3.7717 13.8274C3.74691 13.7661 3.73983 13.699 3.75126 13.6339L4.33858 10.2076C4.37749 9.98142 4.36074 9.74914 4.28977 9.53087C4.2188 9.3126 4.09575 9.1149 3.93126 8.95485L1.44066 6.52999C1.39306 6.484 1.35933 6.42558 1.34331 6.36136C1.32729 6.29714 1.32962 6.22971 1.35005 6.16675C1.37048 6.1038 1.40818 6.04784 1.45885 6.00527C1.50952 5.96269 1.57113 5.9352 1.63666 5.92594L5.07989 5.42256C5.16933 5.40286 5.25824 5.38085 5.34655 5.35656M1.3341 1.3328L14.667 14.6672",
    stroke: "#3265AA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg96C95);
export default __webpack_public_path__ + "static/media/96c95.2a0f1c6f68f361d815fec06b80d2367d.svg";
export { ForwardRef as ReactComponent };